const initialState={	
	
	estadoCuenta:0,
	Consolas:"",
	account_filter:""
	
};


export default function cuentaReducer(state= initialState,action){
	switch(action.type){

		case 'ESTADO':
     		return {...state,estadoCuenta:action.payload};
     	case 'CONSOLAS':
     		return {...state,Consolas:action.payload.Consolas};
     	case 'ACCOUNT_FILTER':
     		return {...state,account_filter:action.payload};
     	default:
     		return state
	}
}